var ActionType = {
    openPopup: 'openPopup',
    openNewTab: 'openNewTab',
    openInAppLink: 'openInAppLink',
};

var BannerCategory = {
    QuickLinks: 'quickLinks',
    Promotions: 'promotions',
    Skyscrapers: 'skyscrapers',
    Virtuals: 'virtuals',
    Games: 'games',
    GamesNewDesktop: 'gamesNewDesktop',
    GamesNewMobile: 'gamesNewMobile',
    PromotedTournaments: 'promotedTournaments',
    PromotionsV2: 'promotionsV2',
    GamesV2: 'gamesV2',
    Registration: 'registration',
    ResponsibleGaming: 'responsibleGaming',
};

var ErrorRoutes = {
    NotFound: 'Not Found',
    NotAuthorized: 'Not Authorized',
};

var FreeToPlayRoutes = {
    SuperSpin: 'Super Spin',
    SuperShot: 'Super Shot',
};

var GamingRoutes = {
    Bingo: 'Bingo',
    CasinoLiveGame: 'Casino Live Game',
    LotteryLanding: 'Lottery landing',
    MyCasinoBingo: 'myCasinoBingo',
    MyCasinoCategory: 'myCasinoCategory',
    MyCasinoLive: 'myCasinoLive',
    MyCasinoVirtuals: 'myCasinoVirtuals',
    MyCasinoHome: 'myCasinoHome',
    MyCasinoGames: 'myCasinoGames',
    MyCasinoGryKarciane: 'myCasinoGryKarciane',
    MyCasinoWirtualne: 'myCasinoWirtualne',
    MyCasinoSearch: 'myCasinoSearch',
    GamesSuperTypeCasino: 'gamesSuperTypeCasino',
    GamesSuperTypeDice: 'gamesSuperTypeDice',
    GamesSuperTypeLiveCasino: 'gamesSuperTypeLiveCasino',
    GamesSuperTypeVirtual: 'gamesSuperTypeVirtual',
    VirtualGameGR: 'Virtual Game GR',
    VirtualGame: 'Virtual Game',
    VirtualResults: 'virtualResults',
    VirtualShopsResults: 'virtualShopsResults',
    BonusGalaxy: 'Bonus Galaxy',
    CasinoGame: 'Casino Game',
};

var TicketRoutes = {
    Tickets: 'Tickets',
    VerifyTicket: 'Verify Ticket',
    CustomerSupportTicket: 'Customer Support Ticket',
    MyBets: 'My Bets',
    MyLottoTickets: 'My Lotto Tickets',
};

var SportRoutes = { Landing: 'Landing' };

var ResultRoutes = {
    SportResults: 'sportResults'
};

var MaintenanceType = {
    Global: 'online',
    Sport: 'online.sport',
    Prematch: 'online.sport.prematch',
    Cashout: 'online.sport.cashout',
    Live: 'online.sport.live',
    Gaming: 'online.gaming',
    Casino: 'online.gaming.casino',
    CasinoLive: 'online.gaming.live-casino',
    Bingo: 'online.gaming.bingo',
    Lotto: 'online.lotto',
    Virtual: 'online.gaming.virtuals',
    Results: 'global.results',
    SportResults: 'global.results.sport',
    LiveResults: 'global.results.live',
    LottoResults: 'global.results.lotto',
    VirtualShopResults: 'global.results.virtual-shop',
    VirtualOnlineResults: 'global.results.virtual-online',
};

var SidebarId = {
    MainNavbar: 'mainNavbar',
    AccountMenu: 'accountMenu',
    AccountPageNav: 'accountPageNav',
    SpecialsTimeFilter: 'specialsTimeFilter',
    ResultsPrimaryNav: 'resultsPrimaryNav',
    ResultsSecondaryNav: 'resultsSecondaryNav',
    LottoPrimaryNav: 'lottoPrimaryNav',
    LottoTimeFilterSidebar: 'lottoTimeFilterSidebar',
    SportPrimaryNav: 'sportPrimaryNav',
    SportTimeFilter: 'sportTimeFilter',
    VirtualGamesNav: 'virtualGamesNav',
    GamesNav: 'gamesNav',
};

var SuperOfferKeys = {
    SuperSix: 'superSix',
    SuperCota: 'superKvota',
    SuperExtra: 'superExtra',
};

var SelectionSourceScreen = {
    Unknown: 0,
    MatchDetailsOffer: 100,
    MatchDetailsH2HPerformance: 119,
    MatchDetailsPointByPoint: 121,
    CompetitionDetailsOffer: 201,
    CompetitionDetailsOutrights: 202,
    TeamDetailsOverviewNextMatch: 301,
    PlayerDetailsOverviewNextMatch: 401,
    TicketDetailsBets: 501,
    TicketDetailsWidget: 502,
    TicketDetailsSocial: 503,
    TicketDetailsTicketCopy: 504,
    TicketDetailsSelectionCopy: 505,
    TicketDetailsTicketRecreate: 506,
    TicketMyBetsDesktopOpen: 507,
    TicketMyBetsDesktopSettled: 508,
    TicketMyBetsDesktopPrepared: 509,
    HomeSuperLive: 601,
    HomeSuperOdds: 602,
    HomeInPlay: 603,
    HomeTopTen: 604,
    HomeSuperExtra: 605,
    HomeTopPriceBoost: 610,
    HomePopularSuperbets: 606,
    LiveSuperLive: 701,
    LiveCompetitions: 702,
    SportsCalendarPopularEvents: 801,
    SportsCalendarPopularSuperbets: 802,
    SportsCalendarCompetitions: 803,
    SportsCalendarsDailyTicket: 804,
    SportsFeaturedPopularEvents: 805,
    SportsFeaturedSuperOdds: 806,
    SportsFeaturedPopularSuperbets: 807,
    SportsCalendarSuperOdds: 808,
    SportsCalendarTopTen: 809,
    SportsCalendarSuperExtra: 810,
    SportsCalendarTopPlayers: 811,
    SportsSuperAdvantagePages: 812,
    SportsCalendarPopularAccumulators: 813,
    SportsCalendarPopularAccumulatorsAddMoreSelections: 815,
    PriceBoostPages: 816,
    SportsExperimentalPopularSuperbets: 899,
    SearchUpcoming: 901,
    BettingRoomOffer: 1001,
    SpecialsDetails: 1101,
    NewsArticleArticleBody: 1201,
    NewsArticleRelatedMatch: 1202,
    SuperSocialBetswipe: 1301,
    SuperSocialFeedExplore: 1302,
    SuperSocialVideoContent: 1303,
    UserAnalysisDetails: 1401,
    UserAnalysisLists: 1402,
    UserAnalysisListTicketDetails: 1403,
    UserAnalysisListSocialProfile: 1404,
    UserAnalysisListPopularAnalyses: 1405,
    UserAnalysisListMatchDetails: 1406,
    UserAnalysisListSocialProfileTab: 1407,
    UserAnalysisListCompetitionDetails: 1408,
    BetCreator: 1501,
    MultiEventBetBuilder: 1701,
    TopWinners: 1801,
};

var SelectionSourceType = {
    Unknown: 0,
    Regular: 101,
    BetBuilder: 201,
    SuperBets: 202,
};

var SuperAdvantageEligibility = {
    Prematch: 'SA_PREMATCH',
    All: 'SA_ALL',
};

var TicketStatus = {
    Active: 'active',
    Canceled: 'canceled',
    Lost: 'lost',
    Obsolete: 'obsolete',
    Paid: 'payed',
    Refund: 'refund',
    Win: 'win',
    CashedOut: 'cashedOut',
};

var TicketType = {
    Sport: 'sport',
    Lotto: 'lotto',
    LuckySix: 'LuckySix',
    Greyhound: 'GreyhoundRaces',
};

var UserJourneyRoutes = {
    Deposit: 'Deposit',
    Profile: 'Profile',
    AccountContainer: 'AccountContainer',
};

var PaymentProviderName = {
    ApplePay: 'Apple Pay',
    Mastercard: 'Mastercard',
    Visa: 'Visa',
    Abon: 'A-bon',
    Skrill: 'Skrill',
    Revolut: 'Revolut',
    Paysafe: 'Paysafe Card',
    Neteller: 'Neteller',
    Przelewy24: 'Przelewy 24',
    PayPal: 'PayPal',
    Blik: 'Blik',
    VisaSecure: 'VisaSecure',
    IdCheck: 'IdCheck',
    MaestroSign: 'MaestroSign',
    MastercardSign: 'MastercardSign',
    Dina: 'Dina',
    Cash: 'Cash',
    BankTransfer: 'Bank transfer',
    BankPoland: 'Bank Poland',
};

var WikiRoutes = {
    Wiki: 'Wiki',
};

var ShopsRoutes = {
    Shops: 'Shops',
};

var SocialRoutes = {
    Home: 'Social',
    TicketFeed: 'TicketFeed'
};

var AccountRoutes = {
    Register: 'Account.Register',
    Container: UserJourneyRoutes.AccountContainer,
    Deposit: UserJourneyRoutes.Deposit,
    History: 'Account.History',
    PasswordUpdate: 'Account.PasswordUpdate',
    Profile: UserJourneyRoutes.Profile,
    Settings: 'Account.Settings',
    Withdrawal: 'Account.Withdrawal',
    DocumentUpload: 'Account.DocumentUpload',
    ResponsibleGaming: 'Account.ResponsibleGaming',
    MyMessages: 'Account.MyMessages',
    PasswordRecovery: 'Account.PasswordRecovery',
    Recovery: 'Account.Recovery',
    Activate: 'Account.Activate',
    ContinueRegistration: 'Account.ContinueRegistration',
    ResendActivationEmail: 'Account.ResendActivationEmail',
    PaymentGatewayStatus: 'Account.PaymentGatewayStatus',
    Bonus: 'Account.Bonus',
    PromotionHub: 'Account.PromotionHub',
    MySocial: 'Account.MySocial',
    EditMySocial: 'Account.EditMySocial',
    BlockedUsers: 'Account.BlockedUsers',
};

var ProductType;
(function (ProductType) {
    ProductType["Casino"] = "Casino";
    ProductType["CasinoLive"] = "CasinoLive";
    ProductType["Virtual"] = "Virtual";
    ProductType["Sport"] = "Sport";
    ProductType["SportSpecials"] = "SportSpecials";
    ProductType["Lotto"] = "Lotto";
    ProductType["News"] = "News";
    ProductType["Shops"] = "Shops";
    ProductType["SuperSpin"] = "SuperSpin";
    ProductType["Base"] = "Base";
})(ProductType || (ProductType = {}));

var BetSlipPurchaseType;
(function (BetSlipPurchaseType) {
    BetSlipPurchaseType["online"] = "online";
    BetSlipPurchaseType["offline"] = "offline";
})(BetSlipPurchaseType || (BetSlipPurchaseType = {}));

var CashoutSource = {
    DesktopWidget: 'desktopWidget',
    TicketList: 'ticketList',
    TicketDetails: 'ticketDetails',
    RetryButton: 'retryButton',
    Social: 'social',
};

var BonusType = {
    Sport: 'Sport',
    Freebet: 'Freebet',
    Casino: 'Casino',
    FreeSpins: 'FreeSpins',
    Virtuals: 'Virtuals',
    CasinoVirtuals: 'CasinoVirtuals',
    Cash: 'Cash',
    Bingo: 'Bingo',
    LiveDealer: 'LiveDealer',
    HoneyToken: 'HoneyToken',
};

var SelectionType = {
    sport: 'sport',
    special: 'specials'
};

var BetType = {
    prematch: 'prematch',
    live: 'live',
    lotto: 'lotto',
    specials: 'specials',
};

var EventStatus = {
    active: 'active',
    lost: 'lost',
    win: 'win',
    refund: 'refund',
};

var EventType = {
    static: 'static',
    live: 'live',
};

var PaymentBonusType = {
    Unspecified: 0,
    NoBonus: 1,
    Wagering: 2,
    FreeBet: 3,
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var TicketSubmitValidationError = /** @class */ (function (_super) {
    __extends(TicketSubmitValidationError, _super);
    function TicketSubmitValidationError(errors) {
        var _newTarget = this.constructor;
        var _this = _super.call(this) || this;
        _this.errors = errors;
        // we need this if we wanna correct instanceof behaviour
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return TicketSubmitValidationError;
}(Error));

var Site = {
    SuperbetRo: 'SuperbetRo',
    SuperbetPl: 'SuperbetPl',
    SuperbetRs: 'SuperbetRs',
    SuperbetCom: 'SuperbetCom',
    SuperbetBr: 'SuperbetBr',
    SuperbetBg: 'SuperbetBg',
    NapoleonCasino: 'NapoleonCasino',
    NapoleonGames: 'NapoleonGames',
    NapoleonSports: 'NapoleonSports',
    NapoleonDice: 'NapoleonDice',
    SuperSocialBr: 'SuperSocialBr',
    NapoleonGamesRo: 'NapoleonGamesRo',
};

var NavigationContext = {
    Sports: 'Sports',
    Casino: 'Casino',
    Neutral: 'Neutral',
};

var NavigationKind = {
    SingleDomain: 'SingleDomain',
    MultipleDomain: 'MultipleDomain',
};

var OddStatus = {
    Unspecified: 'UNSPECIFIED',
    Active: 'ACTIVE',
    Blocked: 'BLOCKED',
    Refund: 'REFUND',
    Canceled: 'CANCELED',
    Win: 'WIN',
    Lost: 'LOST',
};

var AnalyticsAction = {
    Classic: 'Classic',
    Click: 'click',
    Intent: 'Intent'
};

var AnalyticsEvent = {
    PageView: 'pageview',
    WithdrawError: 'withdrawError',
    WithdrawComplete: 'withdrawComplete',
    Deposit: 'deposit',
    DepositError: 'depositError',
    DepositCompleteSB: 'depositComplete_sb',
    DepositCompleteFD: 'depositComplete_fd',
};

var EventCardLocation = {
    Home_Top10: 'Home_Top10',
    Home_SuperAdvantage: 'Home_Super_Advantage',
    Home_SuperKvota: 'Home_Super_Kvota',
    Home_SuperExtra: 'Home_Super_Extra',
    Sport_Calendar: 'Sport_Calendar',
    Sport_PopularEvents: 'Sport_Popular_Events',
    Search: 'Search_Screen',
    Competition: 'Competition_Details',
    Favorite: 'Favorite_Screen',
    News: 'News_Details',
    SuperAdvantage: 'Super_Advantage_Screen',
    Unknown: 'Unknown',
};

var OfferStatus = {
    Prematch: 'prematch',
    Live: 'live',
    Postmatch: 'postmatch',
};

var SuperbetsLocation = {
    Carousel: 'Carousel',
    MarketGroup: 'MarketGroup',
    Sport_PopularSuperbets: 'PopularSuperbets',
    ArticleDetails: 'ArticleDetails',
    Home_PopularSuperbets: 'PopularSuperbetsHome',
    Unknown: 'Unknown',
};

var IdentityProvider = {
    ItsMe: 'itsme',
    MojeId: 'mojeid',
};

var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Success"] = "success";
    PaymentStatus["Cancel"] = "cancel";
    PaymentStatus["Pending"] = "pending";
    PaymentStatus["Failed"] = "failed";
    PaymentStatus["Error"] = "failed";
})(PaymentStatus || (PaymentStatus = {}));

var TransactionStatusType;
(function (TransactionStatusType) {
    TransactionStatusType["Success"] = "success";
    TransactionStatusType["Pending"] = "pending";
    TransactionStatusType["Failed"] = "failed";
    TransactionStatusType["Cancel"] = "cancel";
})(TransactionStatusType || (TransactionStatusType = {}));

var TransactionType;
(function (TransactionType) {
    TransactionType["Deposit"] = "deposit";
    TransactionType["Withdrawal"] = "withdrawal";
})(TransactionType || (TransactionType = {}));

var Locale;
(function (Locale) {
    Locale["English"] = "en-GB";
    Locale["EnglishBelgian"] = "en-BE";
    Locale["EnglishBrazilian"] = "en-BR";
    Locale["Romanian"] = "ro-RO";
    Locale["Polish"] = "pl-PL";
    Locale["Serbian"] = "sr-Latn-RS";
    Locale["DutchBelgian"] = "nl-BE";
    Locale["FrenchBelgian"] = "fr-BE";
    Locale["PortugueseBrazilian"] = "pt-BR";
    Locale["Bulgarian"] = "bg-BG";
})(Locale || (Locale = {}));
var IsoLanguageCode;
(function (IsoLanguageCode) {
    IsoLanguageCode["England"] = "en";
    IsoLanguageCode["Romania"] = "ro";
    IsoLanguageCode["Poland"] = "pl";
    IsoLanguageCode["Serbian"] = "rs";
    IsoLanguageCode["Dutch"] = "nl";
    IsoLanguageCode["French"] = "fr";
    IsoLanguageCode["Portuguese"] = "pt";
    IsoLanguageCode["Bulgarian"] = "bg";
})(IsoLanguageCode || (IsoLanguageCode = {}));

var Country;
(function (Country) {
    Country["Ro"] = "ro";
    Country["Pl"] = "pl";
    Country["Com"] = "com";
    Country["Rs"] = "rs";
    Country["Be"] = "be";
    Country["Bg"] = "bg";
    Country["Br"] = "br";
    Country["BrSocial"] = "brsocial";
    Country["RoNapoleon"] = "ronapoleon";
})(Country || (Country = {}));

var BonusRoutes = {
    PromotionHub: 'BonusAndComms.PromotionHub',
};

export { AccountRoutes, ActionType, AnalyticsAction, AnalyticsEvent, BannerCategory, BetSlipPurchaseType, BetType, BonusRoutes, BonusType, CashoutSource, Country, ErrorRoutes, EventCardLocation, EventStatus, EventType, FreeToPlayRoutes, GamingRoutes, IdentityProvider, IsoLanguageCode, Locale, MaintenanceType, NavigationContext, NavigationKind, OddStatus, OfferStatus, PaymentBonusType, PaymentProviderName, PaymentStatus, ProductType, ResultRoutes, SelectionSourceScreen, SelectionSourceType, SelectionType, ShopsRoutes, SidebarId, Site, SocialRoutes, SportRoutes, SuperAdvantageEligibility, SuperOfferKeys, SuperbetsLocation, TicketRoutes, TicketStatus, TicketSubmitValidationError, TicketType, TransactionStatusType, TransactionType, UserJourneyRoutes, WikiRoutes };
//# sourceMappingURL=index.esm.js.map
